import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateUser } from '@/actions/user';
import DetailTitle from '@/components/shoppings/DetailTitle';
import useUser from '@/hooks/useUser';
import { useUiStatus } from '@/hooks/useUiStatus';
import { favoritePost } from '@/domains/firestore/user';
import { IShopping } from '@/@types/generated/contentful';

type ComponentProps = {
  shopping: IShopping;
};

const DetailTitleContainer: React.FC<ComponentProps> = ({ shopping }) => {
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { setModalState } = useUiStatus();
  const user = useUser();
  const isFavorite = !!user?.favorited?.includes(shopping.fields.id);
  const handleRequestUpdateFavorite = useCallback(
    async (postId: string) => {
      if (!user) {
        setModalState(true);
      } else {
        setLoading(true);
        await favoritePost({ userId: user.uid, postId });
        await dispatch(updateUser(user.uid));
        setLoading(false);
      }
    },
    [dispatch, setModalState, user]
  );
  return (
    <DetailTitle
      shopping={shopping}
      onRequestUpdateFavorite={handleRequestUpdateFavorite}
      isFavorite={isFavorite}
      invalid={isLoading}
    />
  );
};

export default DetailTitleContainer;
